var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var FreeHtml = /** @class */ (function (_super) {
    __extends(FreeHtml, _super);
    function FreeHtml() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FreeHtml.prototype.renderHtml = function () {
        return {
            __html: this.props.html
        };
    };
    FreeHtml.prototype.render = function () {
        return (React.createElement("div", { dangerouslySetInnerHTML: this.renderHtml(), className: "rj-free-html" }));
    };
    return FreeHtml;
}(React.Component));
export { FreeHtml };
//# sourceMappingURL=FreeHtml.js.map